export default __webpack_public_path__ + "static/Plots0012-47547f2216b1bd5dc8f5353a8943afea.jpg";